// extracted by mini-css-extract-plugin
export default {"about":"Menu_about__uVGbr","projects":"Menu_projects__jPukc","menu":"Menu_menu__-hNcQ","active":"Menu_active__p8T9y"};